import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  isMobile,
  wageringStore,
  gameConfigStore,
  applicationStore,
  userSettingsStore,
  getAmountWithCurrency,
  parseNumberByPrecision,
} from '@pascal/pascal-core';

import { doBetStore } from '../../store';
import { fightersList } from '../../enums/uiConfig';
import { globalTranslationKeys } from '../../enums';
import { CurrentAmount } from './currentAmount';

export const FightersCashOutButtons = observer(
  ({ t, oddData, betData, currentJetsInfo, setActiveCurrentSection }) => {
    const { isHalfCashOutOn } = userSettingsStore;
    const { limits } = gameConfigStore;
    const { partnerWageringOdd } = wageringStore;
    const { TryAgain, NoBet, CashOut, YouWin } = globalTranslationKeys;

    const activeCashOutTabCountClassName = useMemo(() => {
      const betFighterData = betData.filter((el) => el.betId);

      if (betFighterData.length === 1) {
        return 'one-active';
      }
      if (betFighterData.length === 2) {
        return 'two-active';
      }
      if (betFighterData.length === 3) {
        return 'three-active';
      }

      return '';
    }, [betData]);

    return (
      <div className='bottom-cash-out-container'>
        <div
          className={`bottom-cash-out-container-inner ${
            isMobile() ? activeCashOutTabCountClassName : ''
          }`}
        >
          {betData.map((item) => (
            // ADD CLASS " disabled "
            <div
              className={`bottom-cash-out-tabs ${!item.betId ? 'disabled' : ''}`}
              key={item.fighterNumber}
            >
              {/*  ADD Class "fighter1, fighter2, fighter3, state-try-again "  */}
              <div
                className={`bet-inner-container ${fightersList[item.fighterNumber].className} ${
                  item.betId &&
                  !item.finishedOdd &&
                  ((item.freeBetId && item.freeBetMinOdd > oddData) ||
                    (partnerWageringOdd && partnerWageringOdd > oddData))
                    ? 'passive'
                    : ''
                } ${
                  item.betId && item.finishedOdd && !item.winAmount && !item.halfWinAmount
                    ? 'state-try-again'
                    : ''
                }`}
                // style={{
                //   display: isMobile() && !item.betId ? 'none' : '',
                // }}
                key={item.fighterNumber}
              >
                {/* this buttons wil be changed */}
                <div
                  className='cash-out-head-button'
                  onClick={() => {
                    setActiveCurrentSection(item.fighterNumber);
                    if (item.isBetAccepted) {
                      doBetStore.sendCashOut(item.betId, item.fighterNumber);
                    }
                  }}
                >
                  {/* ADD CLASS " type-cash-out, state-no-bet, try-again " */}
                  <button
                    className={`bet-button ${!item.betId && oddData ? 'state-no-bet' : ''}${
                      !item.finishedOdd && item.betId && !item.winAmount ? 'type-cash-out' : ''
                    }${
                      item.betId && item.finishedOdd && !item.winAmount && !item.halfWinAmount
                        ? 'try-again'
                        : ''
                    } ${
                      item.winAmount || (item.finishedOdd && item.halfWinAmount) ? 'state-win' : ''
                    }`}
                  >
                    <span className='big-button-cash-out-text'>
                      {item.finishedOdd && item.betId && !item.halfWinAmount && !item.winAmount
                        ? t(TryAgain)
                        : !item.betId && oddData
                        ? t(NoBet)
                        : item.betId && !item.finishedOdd && !item.winAmount
                        ? t(CashOut)
                        : `${t(YouWin)} ${getAmountWithCurrency({
                            amount:
                              item.freeBetId &&
                              item.freeBetMaxPayout < (item?.winAmount || item.halfWinAmount)
                                ? item.freeBetMaxPayout
                                : parseNumberByPrecision(
                                    Number(item?.winAmount) || Number(item?.halfWinAmount),
                                    1
                                  ),
                            isShowRealCurrency: !applicationStore.isDemo,
                          })}`}
                    </span>
                    {oddData && item.isBetAccepted && !item.finishedOdd ? (
                      <CurrentAmount
                        item={item}
                        currentJetsInfo={currentJetsInfo}
                        limits={limits}
                        isDemo={applicationStore.isDemo}
                      />
                    ) : (
                      <></>
                    )}
                  </button>
                </div>
                {isHalfCashOutOn && !item.winAmount && !item.finishedOdd && item.betId ? (
                  <div className='cash-out-50-btn-cont'>
                    {/* ADD CLASS " cashed " */}
                    <button
                      className={`cash-out-50-btn ${item.isHalfCashOut ? 'cashed' : ''} ${
                        !item.isHalfCashOut &&
                        currentJetsInfo[item.fighterNumber] * item.amount >=
                          (item.freeBetId ? item.freeBetMaxPayout : limits.maxWin)
                          ? 'disabled'
                          : ''
                      }`}
                      onClick={() => {
                        setActiveCurrentSection(item.fighterNumber);
                        if (!item.isHalfCashOut) {
                          doBetStore.sendCashOut(item.betId, item.fighterNumber, true);
                        }
                      }}
                    >
                      <span className='cash-out-50-btn-text'>
                        {item.isHalfCashOut
                          ? t(globalTranslationKeys.Cashed)
                          : t(globalTranslationKeys.CashOut)}
                      </span>
                      <span className='cash-out-text-half'>50%</span>
                    </button>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
);
